import userPreferences from './userPreferences';
export default userPreferences;